export default __webpack_public_path__ + "static/media/alert_icon.2f0f1a47.svg";